import { IActivityModel } from '../Activity/Activity';
import { attr, Model } from 'redux-orm';
import { AppAction } from 'src';
import { ISession, IORMModels } from 'src/Config/ConfigureOrm';
import { SET_SELECTED_ACTIVITY } from './PortalState.Actions';
import { IActivityThemeModel } from '../ActivityTheme/ActivityTheme';
import { IActivityCategoryModel } from '../ActivityCategory/ActivityCategory';





export interface IPortalState{
    id: number;
    SelectedActivity: IActivityModel;
    SelectedTheme: IActivityThemeModel;
    SelectedCategory: IActivityCategoryModel;

}


export default class PortalState extends Model<IPortalState> implements IPortalState {
    public static modelName = 'PortalState'
    public static fields = {
        id: attr({})

    }


    public static reducer(action: AppAction<any>, portalSate: typeof Model, session: ISession<IORMModels>) {
        switch(action.type){
            case SET_SELECTED_ACTIVITY : 
                const actId = action.payload.activityId
                const catId = action.payload.categoryId
                const themeId = action.payload.themeId
                const activity: IActivityModel= session.Activity.withId(actId)

                let category: IActivityCategoryModel;
                let theme: IActivityThemeModel;
                if(catId.length < 1){
                    category = session.ActivityCategory.withId(activity.categoryId.toString());
                }
                else{
                    category = session.ActivityCategory.withId(catId);
                }
                
                if(themeId.length < 1){
                   theme = session.ActivityTheme.withId(category.themeId.toString());
                }
                else{
                    theme = session.ActivityTheme.withId(themeId);
                }
                
                portalSate.upsert<IPortalState>({id: 0, SelectedActivity: activity, SelectedTheme: theme, SelectedCategory: category})
            break;
        }

    }

    public id: number;
    public SelectedActivity: IActivityModel;
    public SelectedTheme: IActivityThemeModel;
    public SelectedCategory: IActivityCategoryModel;
}



// WEBPACK FOOTER //
// ./src/Entities/PortalState/PortalState.ts